"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const TabContext_1 = require("./TabContext");
const lib_1 = require("../../lib");
const Tabs = ({ onChange, activeTab, children, compact, className, }) => {
    const [state, setState] = (0, react_1.useState)({
        activeTab,
    });
    (0, react_1.useEffect)(() => {
        setState((state) => (Object.assign(Object.assign({}, state), { activeTab })));
    }, [activeTab]);
    const onTabClick = (0, react_1.useCallback)((name) => {
        if (onChange)
            onChange(name);
    }, [onChange]);
    const context = (0, react_1.useMemo)(() => {
        const ctx = {
            state,
            setState,
            onTabClick,
            compact,
        };
        return ctx;
    }, [onTabClick, state, setState, compact]);
    return ((0, jsx_runtime_1.jsx)(TabContext_1.TabContext.Provider, Object.assign({ value: context }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, lib_1.classnames)(className, (0, lib_1.bem)("tabs", (0, lib_1.use)(compact, "--compact"))) }, { children: children }), void 0) }), void 0));
};
exports.Tabs = Tabs;
//# sourceMappingURL=Tabs.js.map